export const INVENTORY_CREATE_REQUEST = "INVENTORY_CREATE_REQUEST";
export const INVENTORY_CREATE_SUCCESS = "INVENTORY_CREATE_SUCCESS";
export const INVENTORY_CREATE_FAIL = "INVENTORY_CREATE_FAIL";
export const INVENTORY_CREATE_RESET = "INVENTORY_CREATE_RESET";

export const INVENTORY_DETAILS_REQUEST = "INVENTORY_DETAILS_REQUEST";
export const INVENTORY_DETAILS_SUCCESS = "INVENTORY_DETAILS_SUCCESS";
export const INVENTORY_DETAILS_FAIL = "INVENTORY_DETAILS_FAIL";

export const INVENTORY_SALES_REQUEST = "INVENTORY_SALES_REQUEST";
export const INVENTORY_SALES_SUCCESS = "INVENTORY_SALES_SUCCESS";
export const INVENTORY_SALES_FAIL = "INVENTORY_SALES_FAIL";
export const INVENTORY_SALES_RESET = "INVENTORY_SALES_RESET";

export const INVENTORY_UPDATE_REQUEST = "INVENTORY_UPDATE_REQUEST";
export const INVENTORY_UPDATE_SUCCESS = "INVENTORY_UPDATE_SUCCESS";
export const INVENTORY_UPDATE_FAIL = "INVENTORY_UPDATE_FAIL";
export const INVENTORY_UPDATE_RESET = "INVENTORY_UPDATE_RESET";

export const INVENTORY_LIST_REQUEST = "INVENTORY_LIST_REQUEST";
export const INVENTORY_LIST_SUCCESS = "INVENTORY_LIST_SUCCESS";
export const INVENTORY_LIST_FAIL = "INVENTORY_LIST_FAIL";

export const INVENTORY_DELETE_REQUEST = "INVENTORY_DELETE_REQUEST";
export const INVENTORY_DELETE_SUCCESS = "INVENTORY_DELETE_SUCCESS";
export const INVENTORY_DELETE_FAIL = "INVENTORY_DELETE_FAIL";
export const INVENTORY_DELETE_RESET = "INVENTORY_DELETE_RESET";
